import React from "react";

import { Icon } from "aible";

import { Popover, OverlayTrigger } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBullseye,
  faTrash,
  faSyncAlt,
  faCheckCircle,
  faInfo,
  faCircle,
  faUser,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import { ProblematicPredictor } from "components/CreateWizard/Dataset/Correlation";
import { ReviewDatasetHeader, ExpansionItem } from "components/CreateWizard/Academic/AcademicReviewDataset";

import { isEnabled } from "utils/featureFlags";

import styles from "./style.module.css";

export default class ProblematicPredictors extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showExpandedDescription: false,
      showAllPredictors: false
    };
  }

  renderIcon() {
    const { highlightWarning, isSense } = this.props;

    return isEnabled("aible-sense") && false ? (
      <div>
        <FontAwesomeIcon icon={faCheckCircle} style={{ color: "#34D399" }} />
      </div>
    ) : (
      <React.Fragment>
        {isSense ? (
          <div className={styles.problematicPredictorWarningIcon}>
            <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "#F8CD7E" }} />
          </div>
        ) : highlightWarning || true ? (
          <div
            style={{
              borderRadius: "50%",
              backgroundColor: "#F8CD7E",
              height: isSense ? "20px" : "24px",
              width: isSense ? "20px" : "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "2px"
            }}
          >
            <Icon type={"warning"} size={isSense ? 16 : 18} />
          </div>
        ) : (
          <Icon type={"warning"} size={isSense ? 16 : 18} />
        )}
      </React.Fragment>
    );
  }

  renderDescription() {
    const { expandableDescription, selectedDataset, isSense } = this.props;

    const defaultText = isSense
      ? "If any of these fields are only known after " +
        selectedDataset?.outcome +
        " status has been decided, removing them may increase the quality of your charts or predictive model."
      : "The following columns are very good predictors of " +
        selectedDataset.outcome +
        ". (Maybe a little too good...) Would your AI have access to this information at the time of making a prediction? " +
        "If not, you should remove it because otherwise you are expecting your AI to time-travel. " +
        "If they are mathematically related (such as calculated fields), you should also remove them ";

    const onClick = () => {
      this.setState({
        showExpandedDescription: !this.state.showExpandedDescription
      });
    };

    if (expandableDescription) {
      if (this.state.showExpandedDescription) {
        return (
          <React.Fragment>
            <span style={{ marginRight: "8px" }}>{defaultText}</span>
            <a onClick={() => onClick()} style={{ color: "#7E69D7" }}>
              {"Show less"}
            </a>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            <span style={{ marginRight: "8px" }}>
              {"Remove any columns that are known only after the outcome occurs"}
            </span>
            <a onClick={() => onClick()} style={{ color: "#7E69D7" }}>
              {"Show more"}
            </a>
          </React.Fragment>
        );
      }
    } else {
      return defaultText;
    }
  }

  render() {
    const { selectedDataset, problematicPredictors, predictors, updateIgnored, ignored, isDataMode, options, isSense } =
      this.props;

    const hasProblematicPredictors = problematicPredictors && problematicPredictors.length > 0;
    const isLocked = isDataMode || (options && options["lock"]);

    const totalCount = problematicPredictors?.length || 0 + predictors?.length || 0;

    const isAllSelected =
      problematicPredictors?.every((field) => ignored?.[field?.label]) &&
      (this.state.showAllPredictors ? predictors?.every((field) => ignored?.[field?.label]) : true);

    return (
      <div className={styles.problematicPredictors}>
        <ReviewDatasetHeader
          icon={
            hasProblematicPredictors ? (
              <React.Fragment>{this.renderIcon()}</React.Fragment>
            ) : (
              <FontAwesomeIcon icon={faCheckCircle} style={{ color: "#34D399" }} />
            )
          }
          header={
            <div className={styles.problematicPredictorsHeader}>
              <div>
                {hasProblematicPredictors
                  ? "Important: " + totalCount + " Problematic Predictors Need Review"
                  : "0 Problematic Predictors Found"}
              </div>
              <div onClick={(e) => e.stopPropagation()}>
                <OverlayTrigger
                  placement="top"
                  trigger={["click"]}
                  rootClose
                  overlay={
                    <Popover id="popover-positioned-top">
                      <div className={styles.aiReadinessOverlay}>
                        <div className={styles.aiReadinessBody}>
                          <strong>{"If you are analyzing data, "}</strong>
                          <span>
                            {
                              "you may want to remove these variables otherwise you may draw charts that would highlight obvious/trivial relationships between the variables."
                            }
                          </span>
                        </div>
                        <div className={styles.aiReadinessBody}>
                          <strong>{"If you are creating a predictive model, "}</strong>
                          <span>
                            {`the following columns are very good predictors of ${selectedDataset?.outcome}. (Maybe a little too good...) Would your model have access to this information at the time of making a prediction? If not, you should remove it because otherwise you are expecting your model to time-travel. If they are mathematically related (such as calculated fields), you should also remove them.`}
                          </span>
                        </div>
                      </div>
                    </Popover>
                  }
                >
                  <div className={styles.aireadinessIcon + " " + styles.isInfo}>
                    <FontAwesomeIcon icon={faInfo} />
                  </div>
                </OverlayTrigger>
              </div>
            </div>
          }
          isSense={isSense}
        />
        {hasProblematicPredictors ? (
          <div className={styles.predictorsSubheader}>
            <div className={styles.selectSubheader}>{this.renderDescription()}</div>
          </div>
        ) : isSense ? (
          <React.Fragment />
        ) : (
          <div className={styles.selectSubheader} style={{ marginLeft: "0px" }}>
            {"No problematic predictors found."}
          </div>
        )}
        {totalCount > 0 && (
          <div
            className={styles.predictorsList}
            style={isSense && !hasProblematicPredictors ? { marginTop: "-10px" } : undefined}
          >
            <ExpansionItem
              limit={problematicPredictors && problematicPredictors.length ? problematicPredictors.length + 1 : 0}
              label={"View all correlations"}
              noHeightLimit={isSense}
              bodyStyle={{ padding: "0px" }}
              footerStyle={isSense ? { fontSize: "13px" } : undefined}
              showAll={this.state.showAllPredictors}
              updateShowAll={(v) => {
                this.setState({ showAllPredictors: v });
              }}
            >
              <ProblematicPredictor
                style={{ minHeight: "unset" }}
                labelOne={
                  <strong style={isSense ? { fontSize: 10, textTransform: "uppercase" } : undefined}>
                    {isDataMode ? "Column" : "Select Column(s) to Exclude"}
                  </strong>
                }
                labelTwo={
                  <strong style={isSense ? { fontSize: 10, textTransform: "uppercase" } : undefined}>
                    Correlation
                  </strong>
                }
                isLocked={true}
                hasCheckbox={!isLocked}
                noIgnore
                noTitle
                isLabel
                showSelectAll={!isDataMode}
                selectAll={() => {
                  const tProbPredicts = problematicPredictors?.map((field) => field?.label);
                  const tPredicts =
                    this.state.showAllPredictors || isAllSelected ? predictors?.map((field) => field?.label) : [];

                  const allPredictors = tProbPredicts.concat(tPredicts);
                  updateIgnored(allPredictors, !isAllSelected);
                }}
                isAllSelected={isAllSelected}
                isSense={isSense}
              />
              {problematicPredictors &&
                problematicPredictors.map((field) => (
                  <ProblematicPredictor
                    style={{ minHeight: "unset" }}
                    key={field.correlationLabel || field.label}
                    predictor={field}
                    updateIgnored={updateIgnored}
                    isIgnored={ignored && ignored[field.label]}
                    isLocked={isLocked}
                    barColor={"#F8CD7E"}
                    color={"#4B495B"}
                    isSense={isSense}
                  />
                ))}
              <div
                style={{
                  width: "100%",
                  borderBottom: "1px solid #868595",
                  margin: "20px 0px"
                }}
              />
              {predictors &&
                predictors.map((field) => (
                  <ProblematicPredictor
                    style={{ minHeight: "unset" }}
                    key={field.correlationLabel || field.label}
                    predictor={field}
                    updateIgnored={updateIgnored}
                    isIgnored={ignored && ignored[field.label]}
                    isLocked={isLocked}
                    barColor={"#5BCF74"}
                    isSense={isSense}
                  />
                ))}
            </ExpansionItem>
          </div>
        )}
      </div>
    );
  }
}
